import {html, TemplateResult} from 'lit';
import {Article, Messages} from "../../../@types/online-reservation.js";
import {addPresentationToIcon} from "../../icon/icon-accessibility.js";
import infoIcon from '@breuni-ui/bdk/dist/design-tokens/images/icons/o-ic-16_info-round.svg';

import '../product-section/product-section.js';
import {Step} from './step.js';

export class ORInformation extends Step{
  constructor(
    private readonly messages: Messages,
    private readonly onNext: () => void,
    private readonly article: Article,
    private readonly skipSizeLayer = false
  ) {
    super();
  }

  protected renderContent (): TemplateResult {
    return html`
      <product-section .article=${this.article}></product-section>
      <ul class="ents-or-benefits">
        <li class="ents-or-benefits-item">
          <div class="ents-or-benefits-item-content">
            <strong class="ents-copy-bold">${this.messages['points_quick_label']}</strong>
            <span class="ents-copy">${this.messages['points_quick_description']}</span>
            <span id="ents-or-tooltip-trigger" class="ents-or-benefits-info" aria-label="Mehr Informationen">
              ${addPresentationToIcon(infoIcon())}
            </span>
            <ents-tooltip
              anchor-id="ents-or-tooltip-trigger"
              content="${this.messages['tooltip']}"
              position="below" delay="0">
            </ents-tooltip>
          </div>
        </li>
        <li class="ents-or-benefits-item">
          <strong class="ents-copy-bold">${this.messages['points_free_label']}</strong>
          <span class="ents-copy">${this.messages['points_free_description']}</span>
        </li>
        <li class="ents-or-benefits-item">
          <strong class="ents-copy-bold">${this.messages['points_flexible_label']}</strong>
          <span class="ents-copy">${this.messages['points_flexible_description']}</span>
        </li>
      </ul>
    `;
  }

  protected renderFooter(): TemplateResult {
    return html`
      <button class="bdk-button"
              type="button"
              variant="primary"
              size="medium"
              full-width=""
              data-test-ents-or-next-button
              @click=${this.onNext}>
        ${this.skipSizeLayer ? this.messages['storeButton'] : this.messages['sizeButton']}
      </button>
    `;
  }

  protected renderTitle(): TemplateResult {
    return html`
      <h2 class="ents-heading-medium">${this.messages['reservationHeader']}</h2>
    `;
  }
}
